import { render } from "./CrossrefAnalyticsView.vue?vue&type=template&id=5987436f&scoped=true"
import script from "./CrossrefAnalyticsView.vue?vue&type=script&lang=js"
export * from "./CrossrefAnalyticsView.vue?vue&type=script&lang=js"

import "./CrossrefAnalyticsView.vue?vue&type=style&index=0&id=5987436f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5987436f"]])

export default __exports__